import { SECTION } from "@/constants/examConstants";

// TOEIC Parts 1-4 are Listening, 5-7 are Reading. Used as a fallback when the
// server payload doesn't tag the section explicitly (older endpoints).
const sectionFromPartNumber = (partNumber) =>
  partNumber >= 1 && partNumber <= 4 ? SECTION.LISTENING : SECTION.READING;

const normalizeQuestion = (q) => ({
  ...q,
  number: q.number ?? q.questionNumber,
  question: q.question ?? q.text ?? "",
  choices: q.choices || [],
});

/**
 * Coerce an exam payload into the shape every shared exam component expects:
 *   exam.parts[].questionGroup[]   (singular, never `questionGroups`)
 *   exam.parts[].section           (always present)
 *   group.questions[].number       (always present, falls back to questionNumber)
 *   group.questions[].question     (always present, falls back to text)
 *   group.questions[].choices      (always an array)
 *
 * Why this exists: the authoritative student exam API returns `questionGroup`,
 * but the public mock test API returns `questionGroups` (plural). Rather than
 * fork every consumer, we normalize once at the page boundary.
 */
export const normalizeExam = (raw) => {
  if (!raw) return null;
  const parts = (raw.parts || []).map((part) => ({
    ...part,
    section: part.section || sectionFromPartNumber(part.partNumber),
    questionGroup: (part.questionGroup || part.questionGroups || []).map(
      (g) => ({
        ...g,
        questions: (g.questions || []).map(normalizeQuestion),
      })
    ),
  }));
  return { ...raw, parts };
};

export default normalizeExam;
